import { isInternalDepartment } from "./internalDepartments";

// Configuración centralizada de zonas (debe coincidir con backend y getDepartamentoInfo)
const ZONAS_CONFIG = {
  centro: {
    nombre: "Centro",
    departamentos: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12A",
      "12B",
      "14",
      "15",
      "16",
      "17",
      "18",
    ],
  },
  loma: {
    nombre: "Loma",
    departamentos: ["19", "20", "21", "22", "23", "24", "25", "26", "27"],
  },
  interno: {
    nombre: "Interno",
    departamentos: ["Boedo"],
  },
};

export const getNombreSector = (
  depto: string | number
): "Centro" | "Loma" | "Interno" => {
  const deptoStr = depto.toString();

  if (isInternalDepartment(deptoStr)) {
    return "Interno";
  }

  // Usar configuración centralizada
  if (ZONAS_CONFIG.centro.departamentos.includes(deptoStr)) {
    return "Centro";
  }
  if (ZONAS_CONFIG.loma.departamentos.includes(deptoStr)) {
    return "Loma";
  }

  // Fallback a lógica numérica solo para casos extremos
  const n = typeof depto === "string" ? parseInt(depto) : depto;
  return n <= 18 ? "Centro" : "Loma";
};
